import { useQuery } from '@tanstack/react-query';
import { fetchMachineQueue, fetchQueues } from '../api/queuesApi.js';

export function useQueues() {
  return useQuery({
    queryKey: ['queues', 'all'],
    queryFn: fetchQueues,
    refetchInterval: 4000
  });
}

export function useMachineQueue(machineId) {
  return useQuery({
    queryKey: ['machine', 'queue', machineId],
    queryFn: () => fetchMachineQueue(machineId),
    enabled: !!machineId,
    refetchInterval: 4000
  });
}
